import { useAuth } from '@kurotetsu/share/context/AuthContext';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PrivateRoute = () => {
  const { user, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) return null;
  if (user) return <Outlet />;
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;
